export var getStatusBadge = function getStatusBadge(status, hasTests) {
  if (status === "finished") {
    return {
      label: "Finished",
      className: "bg-[#002B18] text-white border border-[#00A159]"
    };
  } else if (status === "planned") {
    return {
      label: "Scheduled",
      className: "bg-teal-900 text-white border border-teal-600"
    };
  } else if (status === "in-progress" || status === "arrived" || status === "triaged") {
    return {
      label: "Ongoing",
      className: "bg-[#623E00] text-white border border-[#D88800]"
    };
  } else if (status === "cancelled" || status === "onleave") {
    return {
      label: "Cancelled",
      className: "bg-red-900 text-white border border-red-600"
    };
  }
  return {
    label: "Unknown",
    className: "bg-gray-900 text-white border border-gray-600"
  };
};